import { RelationshipAttributePermissionCoreBase } from "./relationship-attribute-permission.core.base"


export class RelationshipAttributePermissionCore extends RelationshipAttributePermissionCoreBase {

}